export const getContacts = state => state.items;
